import * as React from 'react';

export default function Icon(props) {
  const {url, platform, target} = props;

  if (!platform || `${platform}`.trim() === '' || !url || `${url}`.trim() === '') {
    return null;
  }

  return (
    <div className={`social-channel-icon social-channel-icon--${platform}`}>
      <a href={url} target={target}></a>
    </div>
  );
}
